import { render, staticRenderFns } from "./BaseField.vue?vue&type=template&id=7225b548&scoped=true&"
import script from "./BaseField.vue?vue&type=script&lang=ts&"
export * from "./BaseField.vue?vue&type=script&lang=ts&"
import style0 from "./BaseField.vue?vue&type=style&index=0&id=7225b548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7225b548",
  null
  
)

export default component.exports